import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteboardTextSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0V2.99999H0.999998V0.999998H5.50001V15H2.99999V16H8.99998V15H6.5V0.999998H11V2.99999H12V0L0 0Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default WhiteboardTextSVG;
